import dayjs from 'dayjs';
import { toNumber } from 'lodash';

import { ContributionAmountSideKey } from '../ContributionEmployeesSettings.types';
import { ContributionAccount, ContributionBackendErrors, Recipient } from '../types';

import { hasZeroAmounts } from './disableAccountIfZeroAmounts';

export const EMPTY_ERROR_MESSAGE = 'This field can’t be empty';



export const getAmountInputErrorMessage = (
  contributionAccount: ContributionAccount,
  areErrorsShown?: boolean,
  backendError?: ContributionBackendErrors,
) => {
  const isZeroAmount = hasZeroAmounts(contributionAccount);
  if ((!areErrorsShown || contributionAccount?.isDisabled) && !backendError) return '';
  if ((!contributionAccount?.[ContributionAmountSideKey.EmployeeContributionAmount]
    && !contributionAccount?.[ContributionAmountSideKey.EmployerContributionAmount])
    || isZeroAmount
    || (backendError && backendError === ContributionBackendErrors.VALUE_IS_EMPTY)
  ) {
    return EMPTY_ERROR_MESSAGE;
  }

  return '';
};

export const getAmountSumInputErrorMessage = (
  contributionAccount: ContributionAccount,
  backendError?: ContributionBackendErrors,
) => {
  const contributionSum = () => {
    const erAmount = contributionAccount?.[ContributionAmountSideKey.EmployeeContributionAmount] || '0';
    const emAmount = contributionAccount?.[ContributionAmountSideKey.EmployerContributionAmount] || '0';
    return toNumber(erAmount) + toNumber(emAmount);
  };

  if ((!contributionAccount?.isDisabled
    && contributionAccount?.contributionAmountMax
    && contributionSum() > toNumber(contributionAccount?.contributionAmountMax))
    || (backendError && backendError === ContributionBackendErrors.INCORRECT_VALUE)
  ) {
    return `The sum is more than available to contribute for this employee.${contributionAccount?.contributionAmountMax ? ` To reach limit: $${contributionAccount?.contributionAmountMax}` : ''}`;
  }
  return '';
};

export const getDateInputErrorMessage = (
  contributionAccount: ContributionAccount,
  areErrorsShown?: boolean,
  backendError?: ContributionBackendErrors,
) => {
  if ((!areErrorsShown || contributionAccount?.isDisabled) && !backendError) return '';
  if (!contributionAccount?.contributionDateOn || (backendError && backendError === ContributionBackendErrors.VALUE_IS_EMPTY)) return EMPTY_ERROR_MESSAGE;
  if (((contributionAccount?.contributionDateFrom
    && dayjs(contributionAccount.contributionDateFrom).valueOf() > dayjs(contributionAccount.contributionDateOn).valueOf())
    || (contributionAccount?.contributionDateTo
      && dayjs(contributionAccount.contributionDateTo).valueOf() < dayjs(contributionAccount.contributionDateOn).valueOf()))
    || (backendError && backendError === ContributionBackendErrors.INCORRECT_VALUE)) {
    return 'This plan is not active on the contribution date.';
  }
  return '';
};

export const findRecipientIndexWithError = (recipients: Recipient[]) => recipients
  .findIndex(
    (recipient) => recipient.contributionAccounts
      ?.some((contributionAccount) => getAmountInputErrorMessage(contributionAccount, true)
      || getAmountInputErrorMessage(contributionAccount, true)
      || getDateInputErrorMessage(contributionAccount, true)
      || getAmountSumInputErrorMessage(contributionAccount)
      || getAmountSumInputErrorMessage(contributionAccount)
    )
  );
